export default __webpack_public_path__ + "static/media/btn-hold.37a36e7a.png";